import { createReducer } from '@reduxjs/toolkit';
import {
  closePartnerModal,
  markPartnerModalCompleted,
  openPartnerModal,
  resetPartnerModal,
  setPartnerModalFields,
} from 'actions/ui/modals/modals';

export interface PartnerModalState {
  isVisible: boolean;
  fields: Record<string, string>;
  isCompleted: boolean;
}

const initialState: PartnerModalState = {
  isVisible: false,
  fields: {},
  isCompleted: false,
};

export const partnerModal = createReducer(initialState, builder => {
  builder
    .addCase(openPartnerModal, state => {
      state.isVisible = true;
    })
    .addCase(closePartnerModal, state => {
      state.isVisible = false;
    })
    .addCase(markPartnerModalCompleted, state => {
      state.isCompleted = true;
    })
    .addCase(setPartnerModalFields, (state, action) => {
      state.fields = action.payload;
    })
    .addCase(resetPartnerModal, state => {
      state.fields = {};
      state.isCompleted = false;
      state.isVisible = false;
    });
});
